<template>
  <div class="user-detail-order">
    <el-row :gutter="20" style="width:100%">
      <el-col :span="24" style="width:100%">
        <div class="text-right"></div>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="userDetailOrderInfo.orders" border style="width: 100%">
        <el-table-column prop="cartId" :label="$t('userDetailOrder.orderNo')" align="center">
        </el-table-column>
        <el-table-column prop="appName" :label="$t('userDetailOrder.platform')" align="center">
        </el-table-column>
        <el-table-column prop="shopName" :label="$t('userDetailOrder.shop')" align="center">
        </el-table-column>
        <el-table-column prop="cartType" :label="$t('userDetailOrder.type')" align="center">
          <template slot-scope="scope">
            {{ scope.row.cartType === '3307' ? $t('userDetailOrder.service') : $t('userDetailOrder.product') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('userDetailOrder.name')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.cartType === '3307'">{{ scope.row.prodName }}</span>
            <span v-else>{{ scope.row.prodName }}({{ scope.row.specValue }})</span>
          </template>
        </el-table-column>
        <el-table-column prop="cartNum" :label="$t('userDetailOrder.quantity')" align="center">
        </el-table-column>
        <el-table-column prop="personName" :label="$t('userDetailOrder.userName')" align="center">
        </el-table-column>
        <el-table-column prop="payPrice" :label="$t('userDetailOrder.paymentAmount')" align="center">
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('userDetailOrder.orderStatus')" align="center">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('userDetailOrder.createTime')" align="center">
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-row :gutter="20" class="margin-top">
        <el-col :span="16"></el-col>
        <el-col :span="8">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderList } from '@/api/user/userDetailOrderApi'

export default {
  name: 'UserDetailOrder',
  data() {
    return {
      userDetailOrderInfo: {
        orders: [],
        personId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  beforeDestroy() {
  },
  methods: {
    open(data) {
      this.userDetailOrderInfo.personId = data.userId
      this.loadOrderData()
    },
    loadOrderData() {
      const params = {
        personId: this.userDetailOrderInfo.personId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }
      getOrderList(params).then(res => {
        this.userDetailOrderInfo.orders = res.data
        this.pagination.total = res.records
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadOrderData()
    }
  }
}
</script>

<style scoped>
.user-detail-order {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>